module.exports = __webpack_public_path__ + "static/media/paragon_head_office.e57478fa.jpg";